import { render, staticRenderFns } from "./ToolbarBackButtonComponent.vue?vue&type=template&id=1fc9766a&"
import script from "./ToolbarBackButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ToolbarBackButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBackButtonComponent.vue?vue&type=style&index=0&id=1fc9766a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports